import { Box, Chip, Icon, SxProps, Theme } from "@outschool/backpack";
import { faPartyHorn } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

/**
 *
 * Copy of the FreeForMembersChip component, but with a different layout for the gallery experiment.
 */
export function FreeForMembersChip({ sx }: { sx?: SxProps }) {
  // Use existing translations.
  const { t } = useTranslation("client\\components\\Chips\\FreeForMembersChip");
  return (
    <Box
      flex
      // New styling of the container
      sx={(theme: Theme) => ({
        alignItems: "center",
        gap: "0.5rem",
        justifyContent: "center",
        height: "36px",
        backgroundColor: theme.palette.warning.main,
        width: "100%",
        borderRadius: "8px",
      })}
    >
      {/* New icon for the gallery experiment. */}
      <Icon icon={faPartyHorn} sx={{ color: "primary.dark" }} />
      <Chip
        label={t`Free for members`}
        size="small"
        sx={[
          theme => ({
            color: theme.palette.primary.dark,
            fontWeight: "bold",
            fontSize: "14px",
            backgroundColor: "transparent",
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      />
    </Box>
  );
}
